import React from 'react';
import { CTAButton } from './CTAButton';
import { BoxImage } from './BoxImage';
export function Hero() {
  return <header className="border-t-4 border-aqua bg-navy text-center" data-id="element-87" data-mp="eiv62y7sfcld">
      <div className="px-3 pb-4 pt-3 sm:px-6 sm:pb-5 sm:pt-4" data-id="element-88" data-mp="9kjw8nhht235">
        <h1 className="font-display text-[0.74rem] font-extrabold uppercase leading-tight text-white/90 sm:text-[0.95rem]" data-id="element-89" data-mp="9ipax82b77yj">
          THE COMPLETE <span className="text-aqua" data-id="element-90" data-mp="1297f6cerrfdj">POOL &amp; SPA TROUBLESHOOTING &amp; REPAIR</span> SYSTEM
        </h1>
        <p className="mt-1 font-display text-[1.45rem] font-extrabold uppercase leading-[1.05] text-white sm:text-[2.25rem]" data-id="element-91" data-mp="x9uspsrt8abh">
          STOP GUESSING THE PROBLEM.{' '}
          <span className="text-sun" data-id="element-92" data-mp="sd4c94c3fcpj">START DIAGNOSING WITH A SYSTEM.</span>
        </p>
        <p className="mx-auto mt-1.5 max-w-xl text-[0.8rem] leading-[1.35] text-white/85 sm:text-[0.95rem]" data-id="element-93" data-mp="neaugzprwzjk">
          Identify pool and spa equipment failures, troubleshoot pumps and motors, diagnose circulation
          problems, inspect filtration and heating systems, document faults, and organize repairs—all in
          one complete professional diagnostic system.
        </p>

        <BoxImage className="mx-auto mt-2 max-w-[290px] sm:max-w-[380px]" data-id="element-94" data-mp="3o6u8lem7yzf1" />

        <div className="mx-auto mt-2 max-w-md" data-id="element-95" data-mp="399bctsb4jly3">
          <CTAButton label="🚀 YES! I WANT MY POOL & SPA DIAGNOSTIC SYSTEM NOW" data-id="element-96" data-mp="39cpfl1np9x62" />
          <p className="mt-2 text-[0.68rem] font-bold uppercase tracking-wide text-white/85 sm:text-xs" data-id="element-97" data-mp="3ebisosz2rm5p">
            🛡️ 7-Day Money-Back Guarantee — Zero Risk
          </p>
        </div>
      </div>
    </header>;
}